<template>
  <div
    v-on-clickaway="close"
    class="dropdown relative dropdown--legacy"
    :class="{ disabled: disabled }"
    @keydown.esc="close"
  >
    <slot :toggle="toggle" :active="visible" :close="close"></slot>
    <transition name="fade">
      <slot v-if="visible" name="menu" :close="close"></slot>
    </transition>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway';

  export default {
    mixins: [clickaway],
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      resetMenu: {
        type: Function,
        default: null,
      },
    },
    data: () => ({ visible: false }),
    watch: {
      visible() {
        if (!this.visible && this.resetMenu) {
          this.resetMenu();
        }
      },
    },
    mounted() {
      window.addEventListener('keyup', this.closeOnEscKey);
    },
    beforeDestroy() {
      window.removeEventListener('keyup', this.closeOnEscKey);
    },
    methods: {
      closeOnEscKey(event) {
        if (this.visible && event.keyCode === 27) {
          this.visible = false;
        }
      },
      toggle() {
        if (this.disabled) {
          this.$emit('field-disabled');
          return;
        }
        this.visible = !this.visible;
        this.$emit('toggle', this.visible);
      },
      close() {
        this.visible = false;
      },
    },
  };
</script>
